import React from 'react';
import DefaultLayout from '../layouts/DefaultLayout';

const Landing = () => {
  return (
    <DefaultLayout title="ThrulainSandbox React Web">
      <section className="p-2">
        <h1 className="p-2 md:text-center text-3xl"> Welcome to ThrulainSandbox!</h1>
        <p className="p-2 md:text-center"> Check out the docs on <a target="_blank" rel="noreferrer" href="https://fugitivelabs.github.io/yote/"> GitHub </a></p>
      </section>
    </DefaultLayout>
  )
}

export default Landing;